import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';
import createForm from '@blockcatio/tabby-library/lib/components/form/createForm';
import joi from '@blockcatio/tabby-library/lib/services/joi';
import EthereumAddressInput from '@blockcatio/tabby-library/lib/components/form/elements/EthereumAddressInput';
import TextInput from '@blockcatio/tabby-library/lib/components/form/elements/TextInput';
import SliderInput from '@blockcatio/tabby-library/lib/components/form/elements/SliderInput';

const AddCustomToken = ({ onSubmit, onValidateTokenAddress }) => {
  const form = createForm({
    onSubmit,
    fields: [
      {
        id: 'address',
        label: 'Address',
        inputComponent: EthereumAddressInput,
        fieldOptions: {
          className: 's12 l12 input-with-icon',
        },
        required: true,
        validation: joi
          .ethereumAddress()
          .insensitive()
          .required(),
        checks: [
          async ({ address }) => {
            if (!(await onValidateTokenAddress(address))) {
              throw new Error('Address is not a token contract');
            }
          },
        ],
      },
      {
        id: 'symbol',
        label: 'Symbol',
        inputComponent: TextInput,
        inputOptions: {
          placeholder: '',
        },
        fieldOptions: {
          className: 's12 l12',
        },
        required: true,
        validation: joi.tokenSymbol().required(),
      },
      {
        id: 'name',
        label: 'Name',
        inputComponent: TextInput,
        inputOptions: {
          placeholder: '',
        },
        fieldOptions: {
          className: 's12 l12',
        },
        required: true,
        validation: joi.string().required(),
      },
      {
        id: 'decimals',
        label: 'Decimals',
        inputComponent: SliderInput,
        inputOptions: {
          step: 1,
          min: 1,
          max: 18,
        },
        fieldOptions: {
          className: 's12 l12',
        },
        required: true,
        defaultValue: 18,
        validation: joi
          .number()
          .integer()
          .invalid(0)
          .min(1)
          .max(18)
          .required(),
      },
    ],
    submitText: 'Add Token',
  });
  return (
    <div className="add-custom-token">
      <h2>Enter Token Details</h2>
      {form}
    </div>
  );
};

AddCustomToken.defaultProps = {
  onSubmit: noop,
};

AddCustomToken.propTypes = {
  onSubmit: PropTypes.func,
  onValidateTokenAddress: PropTypes.func.isRequired,
};

export default AddCustomToken;



// WEBPACK FOOTER //
// ./src/components/modals/CustomTokenForm.js